"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useCurrentAnswers = require("../../hooks/questionnaire/useCurrentAnswers");
var _useCurrentQuestion = require("../../hooks/questionnaire/useCurrentQuestion");
var _utils = require("../../utils/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const QuestionTitle = () => {
  const {
    answers
  } = (0, _useCurrentAnswers.useCurrentAnswers)();
  const {
    title,
    subtitle,
    questionIndex,
    topTitle
  } = (0, _useCurrentQuestion.useCurrentQuestion)();
  (0, _useCurrentQuestion.useViewQuestion)(questionIndex);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, topTitle && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: (0, _utils.replacePlaceholders)(topTitle, answers),
    justify: 'center',
    size: 1,
    weight: 2,
    dataAttributes: {
      'data-test-id': 'page-topTitle'
    }
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: title,
    justify: 'center',
    weight: 3,
    size: 2,
    dataAttributes: {
      'data-test-id': 'page-title'
    }
  })))), subtitle && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: (0, _utils.replacePlaceholders)(subtitle, answers),
    justify: 'center',
    size: 1,
    dataAttributes: {
      'data-test-id': 'page-subtitle'
    }
  }))));
};
var _default = QuestionTitle;
exports.default = _default;